import React, { Component } from "react";
import IntelligentInlineHeader from "./components/IntelligentInlineHeader";
import IntelligentMajorDetail from "../IntelligentMajorModal/components/IntelligentMajorDetail";
import "./style.css";
import "../../../../../index.css";
class IntelligentInlineMajorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  componentDidMount() {
    this.fixCss();
  }
  render() {
    const { majorData, visible, handleVisibleMajor } = this.props;
    return (
      <div
        style={{ minHeight: this.state.css.minHeight,zIndex:999 }}
        className={
          visible === true
            ? "intelligentAllMajorModal_box"
            : "intelligentAllMajorModal_box display_none"
        }
      >
        <IntelligentInlineHeader
          handleVisible={handleVisibleMajor}
        ></IntelligentInlineHeader>
        {majorData != null ? (
          <IntelligentMajorDetail item={majorData}></IntelligentMajorDetail>
        ) : (
          ""
        )}
      </div>
    );
  }
  fixCss = () => {
    let minHeight = window.innerHeight;
    this.setState({
      css: {
        minHeight: minHeight,
      },
    });
  };
}

export default IntelligentInlineMajorModal;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentInlineMajorModal/index.js